import React, { useEffect } from "react";
import { Grid, Paper, Stack, Typography } from "@mui/material";
import { AboutPageCmsForm } from "../../../components/admin/cms/about-page";
import AutoCompleteServerSide from "../../../components/Common/AutoCompleteServerSide";
import { useGetAboutPageCmsQuery } from "../../../store/cms/cmsApis";
import { LimitScreenLoadingGrow } from "../../../components/Common/FullScreenLoadingGrow";
import { aboutInitialForm } from "../../../store/cms/cmsSlice";

const AboutPageCmsManagerContainer = (props) => {
    const { aboutInitialValues, sansthaId } = props;
    const [manualLoading, setManualLoading] = React.useState(false);
    const { data, isLoading, isSuccess, isFetching } = useGetAboutPageCmsQuery({ sanstha_id: sansthaId?._id }, { skip: !sansthaId?._id });

    useEffect(() => {
        if (isSuccess && !isFetching) {
            setManualLoading(false);
        }
    }, [isSuccess, isFetching])

    useEffect(() => {
        if (data) {
            props.changeAboutInitialState(data);
            if (isSuccess && !isFetching) {
                setManualLoading(false);
            }
        }
    }, [data])

    const fetchCmsData = (val) => {
        setManualLoading(true);
        props.changeAboutInitialState(aboutInitialForm);
        props.changeSansthaId(val);
    }

    return (
        <Stack spacing={1}>
            <Paper sx={{ marginBottom: "24px", padding: 1.5 }}>
                <Grid container justifyContent="space-between">
                    <Grid item sx={{ alignSelf: "center" }}>
                        <Typography variant="h6">About Page CMS</Typography>
                    </Grid>
                    <Grid item sx={{ minWidth: "400px" }}>
                        <AutoCompleteServerSide
                            label="Type & Select Sanstha *"
                            name="sanstha_id"
                            id="sanstha_id"
                            fullWidth
                            defaultValue={sansthaId}
                            fetchDataFunction={(d) => props.getSansthaList(d)}
                            onChange={(val) => fetchCmsData(val)}
                        />
                    </Grid>
                </Grid>
            </Paper>

            <Grid container>
                <Grid item xs={12}>

                    {
                        isLoading || isFetching || manualLoading
                            ?
                            <Paper
                                sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                                elevation={0}
                            >
                                <LimitScreenLoadingGrow />
                            </Paper>
                            :
                            aboutInitialValues && sansthaId
                                ?
                                <AboutPageCmsForm aboutInitialValues={aboutInitialValues} sansthaId={sansthaId?._id} />
                                :
                                <Paper
                                    sx={{ p: 2, color: "#071B2A", fontWeight: "400" }}
                                    elevation={0}
                                >
                                    <Grid sx={{ display: "flex" }} direction={"column"} width={"100%"} height={"100%"} >
                                        <Typography variant="h6">Please Select Sanstha Id</Typography>
                                    </Grid>
                                </Paper>
                    }

                </Grid>
            </Grid>
        </Stack >
    );
}

export default AboutPageCmsManagerContainer;